import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navLinks, site } from "@/config/site";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-foreground-950/12 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-shell items-center justify-between gap-6 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex items-center gap-3" aria-label={`${site.name} 首页`}>
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 text-background-50 md:h-11 md:w-11">
            <span className="font-heading text-xl font-bold leading-none">料</span>
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              {site.name}
            </span>
            <span className="hidden text-[11px] tracking-[0.24em] text-foreground-500 sm:block">
              {site.tagline}
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/submit"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:flex"
          >
            <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
            我要投稿
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-950/15 text-foreground-900 lg:hidden"
            aria-label={open ? "关闭菜单" : "展开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-foreground-950/10 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full max-w-shell flex-col px-4 py-3" aria-label="移动端导航">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" aria-hidden="true"></i>
              </NavLink>
            ))}
            <Link
              to="/submit"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
              我要投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}